import { render, staticRenderFns } from "./MobileOrderPreview.vue?vue&type=template&id=5f6e7dd6&scoped=true&"
import script from "./MobileOrderPreview.vue?vue&type=script&lang=js&"
export * from "./MobileOrderPreview.vue?vue&type=script&lang=js&"
import style0 from "./MobileOrderPreview.vue?vue&type=style&index=0&id=5f6e7dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e7dd6",
  null
  
)

export default component.exports